import { render, staticRenderFns } from "./TrainingSubmissionModal.vue?vue&type=template&id=7864ab12&scoped=true"
import script from "./TrainingSubmissionModal.vue?vue&type=script&lang=js"
export * from "./TrainingSubmissionModal.vue?vue&type=script&lang=js"
import style0 from "./TrainingSubmissionModal.vue?vue&type=style&index=0&id=7864ab12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7864ab12",
  null
  
)

export default component.exports